require('/opt/odin/app/frontend/pages/home/components/fdo_news/index.module.scss');module.exports = "../../app/cells/pages/home/fdo_news/show.erb";